<template>
  <div class="worldofzain--subcontinets">
    <Header></Header>
        <div class="container">
            <div class="fixed-wrapper">
                <div class="subcontinets_top-bar">
                    <ul>
                        <li>
                            <router-link :to="`/${$i18n.locale}/world-of-zain/middleeast`" class="active">{{$t("labels.middleEast")}}</router-link>
                        </li>
                        <li>
                            <router-link :to="`/${$i18n.locale}/world-of-zain/africa`">{{$t("labels.africa")}}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="landing"> 
            <div class="container">
                <region-stats :stats="this.data.middleEast.stats" :map-image="this.data.middleEast.mapimage"></region-stats>
            </div>
        </div>
        
        <div class="countries-wrapper">
            <svgPath></svgPath>
            <country :countries="this.data.middleEast.countries"></country>
        </div>        
        
  </div>
</template>

<script>
import data from '@/components/worldOfZain/worldOfZain';
import regionStats from '@/components/worldOfZain/regionStats';
import country from '@/components/worldOfZain/country';
import svgPath from '@/components/worldOfZain/path';
export default { 
    data(){
        return{
            data: data
        }
    }, 
    components:{
        regionStats,
        country,
        svgPath
    },
    created(){
        this.$i18n.locale=="en" ? 
            this.data = this.data.en :
            this.data = this.data.ar
    },
    mounted(){
        this.worldOfZain();
    },
}
</script>
<style>
[data-page="worldofzain-middleeast"] .wrapper{
    overflow: hidden;
}
</style>
<style lang="scss" scoped>
@import "@/assets/sccs/worldofzain.scss";

.worldofzain--subcontinets {
    padding-bottom:rem(60px);
    &:after{
        content:"";
        position:absolute;
        width:100%;
        height:100%;
        background: url("../assets/images/banners/worldofzain-continent.jpg") center center no-repeat;
        background-attachment: fixed;
        background-size:cover;
        left:0;
        top:0;
        z-index:-1;

    }
}

[lang="ar"]{
    .worldofzain--subcontinets {
        &:after{
            transform:scaleX(-1);
        }
    }
}

</style>
